var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 34,
    viewBox: "0 0 111 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46292 25.5979H8.3629C3.56992 25.5787 0 22.7605 0 17.521C0 10.0148 5.6595 5.86222 11.8923 5.86222C14.4926 5.86222 16.5192 6.66227 18.2016 8.64332V8.64358L15.2191 11.2723C14.225 10.1291 12.772 9.59601 11.2808 9.59601C7.41838 9.59601 4.01533 12.4914 4.01533 16.8347C4.01533 20.0354 6.19481 21.7882 9.0628 21.7882C10.6687 21.7882 12.3896 21.2928 13.8426 20.0354L16.0603 22.6643C13.6284 24.709 11.1582 25.587 8.46292 25.5979Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1168 6.23001L25.9257 8.70583C27.7605 6.30621 29.978 5.8112 32.004 5.8112C33.8388 5.8112 35.4825 6.4586 36.3617 7.41078L33.9918 10.839C33.1508 10.0771 32.3096 9.69636 30.8569 9.69636C28.1429 9.69636 25.4668 11.3721 24.8553 14.8382L23.0584 25.0079H19.1211L22.4469 6.23001H26.1168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7894 14.1679C55.7894 20.4161 50.8184 25.4838 44.1265 25.4838C38.9643 25.4838 35.9434 22.0167 35.9434 17.3686C35.9434 11.0818 40.9526 5.93817 47.568 5.93817C52.6919 5.93817 55.7894 9.48172 55.7894 14.1679ZM39.9584 16.7966C39.9584 19.5783 41.182 21.8262 44.7767 21.8262C48.9063 21.8262 51.7743 18.4734 51.7743 14.7391C51.7743 11.9199 50.2828 9.55791 46.918 9.55791C42.8647 9.55791 39.9584 13.025 39.9584 16.7966Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5791 33.8099H55.6097V33.636L55.5791 33.8099Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1268 14.8707V14.8723C78.707 20.8643 74.0528 25.4825 67.6561 25.4825C65.3556 25.4825 62.5567 24.642 61.5601 22.3118L59.528 33.8099H55.6097V33.636L60.4484 6.22976H64.167L63.8603 9.28561C65.4344 7.36536 67.7085 6.24944 69.8928 5.9381C70.3155 5.87806 70.7344 5.84778 71.1446 5.84778C71.5913 5.85131 72.0233 5.88184 72.4383 5.9381C76.3524 6.46844 78.8262 9.28031 79.1268 13.1718V13.1733C79.1457 13.421 79.1561 13.6734 79.1573 13.9297V14.0432C79.1561 14.3217 79.1457 14.5977 79.1268 14.8707ZM62.99 16.6823C62.99 12.9487 65.9345 9.74808 70.064 9.74808C73.1996 9.74808 75.1117 11.7675 75.1117 14.7012C75.1117 18.74 71.8229 21.7118 67.9613 21.7118C64.9018 21.7118 62.99 19.5401 62.99 16.6823Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9595 25.0004H82.9032L91.1388 15.3512L86.7904 6.23804L81.4869 6.23814L86.0996 15.4301L77.9595 25.0004Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1512 14.4069L90.3628 10.771L93.9549 6.23804H99.17L92.1512 14.4069Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9459 16.6914L95.8932 25.0004H90.933L88.6558 20.4965L91.9459 16.6914Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.732 0.984686C108.957 6.42679 107.658 7.00632 101.023 5.50211C102.211 0.20407 103.737 -0.530624 110.732 0.984686Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropx);
export default __webpack_public_path__ + "static/media/cropx.77ef2f1fefdad35b9ef18812c216e345.svg";
export { ForwardRef as ReactComponent };